import React from 'react';
import {OdontoUnitsProps} from './types';
import {Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {useOdontoUnits} from './hooks/useOdontoUnits';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {OdontoUnitsNotFoundState} from './components/OdontoUnitsNotFoundState';
import {ScrollToTop} from 'presentation/components';
import {OdontoUnitsSelfNetwork} from './components/OdontoUnitsSelfNetwork';
import {OdontoUnitsSupportAccreditedNetwork} from './components/OdontoUnitsSupportAccreditedNetwork';

const {loadingError, loadingState} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;
const {resultFound} = translations['pt-br'].commons;
const {bookOdonto} = translations['pt-br'].privateFlow.services;

export function OdontoUnits({handleNextStep}: OdontoUnitsProps) {
	const {
		query,
		showLoadingState,
		showErrorState,
		handleRefetchUnits,
		showNotFoundState,
		showSelfNetwork,
		filteredNetworkList,
		showSupportAccreditedNetwork,
	} = useOdontoUnits();

	if (showLoadingState) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookOdonto}
				loadingText={loadingState}
				variant="skeleton"
			/>
		);
	}

	if (showErrorState) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookOdonto}
				errorTitle={loadingError}
				handleRefresh={handleRefetchUnits}
			/>
		);
	}

	if (showNotFoundState) {
		return <OdontoUnitsNotFoundState />;
	}

	return (
		<Stack gap={1}>
			{query ? (
				<Typography variant="subtitle2" color="text.secondary">
					{resultFound}
				</Typography>
			) : null}

			{showSelfNetwork ? (
				<OdontoUnitsSelfNetwork
					handleNextStep={handleNextStep}
					unitsList={filteredNetworkList}
				/>
			) : null}

			{showSupportAccreditedNetwork ? (
				<OdontoUnitsSupportAccreditedNetwork unitsList={filteredNetworkList} />
			) : null}

			<ScrollToTop />
		</Stack>
	);
}
